<template>
    <div class="user-selects-group-wpr">
        <search-down-list ref="select" :disabled="disabled" :leftFormater="leftFormater" :rightFormater="rightFormater" v-model="userValues" :cacheOptions="cacheList" :allowEmail="allowEmail">
            <i title="分组" v-click-outside="hideGroup" :style="disabled ? 'cursor: not-allowed;':''" class="el-icon-menu group-btn" @click="toggleGroup"></i>
            <i title="新加分组"  :style="disabled ? 'cursor: not-allowed;':''" class="el-icon-plus save-to-group" @click="addToGroup"></i>
        </search-down-list>
        <div v-if="showGroupTable" class="group-info">
            <el-table :data="gridData" @row-click="rowClick">
                <el-table-column width="150" prop="recordName" label="组名" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="data" label="成员">
                    <template slot-scope="scope">
                        <el-tag v-for="(item, index) in JSON.parse(scope.row.record)"
                                :key="index" type="primary">{{ item.title || item.name }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column width="50" prop="recordName" label="">
                    <template slot-scope="scope">
                        <el-button :style="disabled ? 'cursor: not-allowed;':''" type="text" icon="el-icon-close" style="float: right;font-size: 14px;" @click.stop="removeItem(scope.row.id)"></el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import SearchDownList from './searchDownList.vue'
    import ClickOutside from './vue-click-outside'
    import axios from 'axios'
    import _ from 'underscore'

    export default {
        props: {
            value: '',
            cacheOptions: {
                type: Array,
                default () {
                    return []
                }
            },
            allowEmail: true,
            disabled: false,
        },
        created () {
            this.getList()
        },
        watch: {
            'cacheOptions': function () {
                this.cacheList = this.cacheOptions
            },
            'value': function () {
                this.userValues = this.value
            },
            'userValues': function () {
                this.$emit('input', this.userValues)
            }
        },
        data () {
            return {
                cacheList: this.cacheOptions,
                enableOutClick: true,
                userValues: this.value,
                emptyText: '无分组信息',
                showGroupTable: false,
                gridData: []
            }
        },
        components: {
            searchDownList: SearchDownList
        },
        directives: {
            ClickOutside
        },
        methods: {
            getList () {
                axios.get('/resumePosition/MailCcRecord/list.api').then(res => {
                    this.gridData = res.result.list
                })
            },
            removeItem (id) {
                if(this.disabled) {
                    return
                }
                this.enableOutClick = false
                this.$confirm('此操作将永久删除改分组, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios.post('/resumePosition/MailCcRecord/delete.api', {
                        id: id
                    }, {
                        'X-showMessage': true
                    }).then(res => {
                        this.getList()
                        this.enableOutClick = true
                    })
                }).catch(() => {
                    this.enableOutClick = false
                })
            },
            addToGroup () {
                if(this.disabled) {
                    return
                }
                this.cacheList = this.$refs.select.getSelected()
                if (this.cacheList.length === 0) {
                    this.$message({
                        type: 'warning',
                        message: '分组成员不能为空'
                    })
                    return false
                }
                this.$prompt('请输入新的分组名', '新加分组', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputPattern: /^[\S]{1,20}$/,
                    inputErrorMessage: '不能为空，不能空字符开头，长度不能超过20'
                }).then(({ value }) => {
                    axios.post('/resumePosition/MailCcRecord/insert.api', {
                        recordName: value,
                        record: JSON.stringify(this.cacheList)
                    }, {
                        'X-showMessage': true
                    }).then(res => {
                        this.getList()
                    })
                }).catch(() => {
                })
            },
            rowClick (data) {
                let list = JSON.parse(data.record)
                this.cacheList = this.$refs.select.getSelected()
                let ids = _.pluck(this.cacheList, 'id')
                list.forEach(item => {
                    if (ids.indexOf(String(item.id)) === -1) {
                        ids.push(item.id)
                        this.cacheList.push({
                            id: item.id,
                            name: item.title || item.name
                        })
                    }
                })
                this.$refs.select.setDefaultValue(this.cacheList, ids.join(','))
                this.$emit('input', ids.join(','))
            },
            leftFormater (obj) {
                return obj.lastName
            },
            rightFormater (obj) {
                var depNames = []
                obj.dept1Name && depNames.push(obj.dept1Name)
                obj.dept2Name && depNames.push(obj.dept2Name)
                obj.dept3Name && depNames.push(obj.dept3Name)
                return depNames.join('->')
            },
            toggleGroup () {
                if(this.disabled) {
                    return
                }
                this.showGroupTable = true
            },
            hideGroup () {
                if (this.enableOutClick && this.showGroupTable === true) {
                    this.showGroupTable = false
                }
            },
            reset () {
                this.$refs.select.reset()
            },
            setDefaultValue (data, ids, conf) {
                this.$refs.select.setDefaultValue(data, ids, conf)
            },
            getSelected () {
                return this.$refs.select.getSelected()
            }
        }
    }
</script>

<style type="text/scss" lang="scss">
    .user-selects-group-wpr {
        position: relative;
        .group-btn,.save-to-group {
            position: absolute;
            right: 60px;
            top: 13px;
            z-index: 2;
            font-size: 12px;
            color: #ddd;
            cursor: pointer;
            &:hover {
                color: #20a0ff;
            }
        }
        .save-to-group{
            right: 35px;
        }
    }
    .group-info{
        color: #ff0000;
        position: absolute;
        top: 40px;
        width: 100%;
        z-index: 10000;
        box-shadow: 1px 1px 1px #ddd;
        .el-table{
            tr{
                cursor: pointer;
                td,th{
                    height: 34px;
                    .cell{
                        border-right: none;
                        border-left: none;
                        text-align: left;
                    }
                }
            }
        }
        .el-tag{
            margin: 5px 5px 5px 0;
        }
    }
</style>


// WEBPACK FOOTER //
// userSelect.vue?7b9daec2